import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { disposables as m } from '../../utils/disposables.js';
import { isIOS as u } from '../../utils/platform.js';
function d() {
  return u() ? {
    before: function before(_ref) {
      var r = _ref.doc,
        l = _ref.d,
        c = _ref.meta;
      function o(a) {
        return c.containers.flatMap(function (n) {
          return n();
        }).some(function (n) {
          return n.contains(a);
        });
      }
      l.microTask(function () {
        var s;
        if (window.getComputedStyle(r.documentElement).scrollBehavior !== "auto") {
          var t = m();
          t.style(r.documentElement, "scrollBehavior", "auto"), l.add(function () {
            return l.microTask(function () {
              return t.dispose();
            });
          });
        }
        var a = (s = window.scrollY) != null ? s : window.pageYOffset,
          n = null;
        l.addEventListener(r, "click", function (t) {
          if (t.target instanceof HTMLElement) try {
            var e = t.target.closest("a");
            if (!e) return;
            var _URL = new URL(e.href),
              f = _URL.hash,
              i = r.querySelector(f);
            i && !o(i) && (n = i);
          } catch (_unused) {}
        }, !0), l.addEventListener(r, "touchstart", function (t) {
          if (t.target instanceof HTMLElement) if (o(t.target)) {
            var e = t.target;
            for (; e.parentElement && o(e.parentElement);) e = e.parentElement;
            l.style(e, "overscrollBehavior", "contain");
          } else l.style(t.target, "touchAction", "none");
        }), l.addEventListener(r, "touchmove", function (t) {
          if (t.target instanceof HTMLElement) if (o(t.target)) {
            var e = t.target;
            for (; e.parentElement && e.dataset.headlessuiPortal !== "" && !(e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth);) e = e.parentElement;
            e.dataset.headlessuiPortal === "" && t.preventDefault();
          } else t.preventDefault();
        }, {
          passive: !1
        }), l.add(function () {
          var e;
          var t = (e = window.scrollY) != null ? e : window.pageYOffset;
          a !== t && window.scrollTo(0, a), n && n.isConnected && (n.scrollIntoView({
            block: "nearest"
          }), n = null);
        });
      });
    }
  } : {};
}
export { d as handleIOSLocking };